import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../component/headerone/Main'
// import { Breadcrumb } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Breadcrumb from '../component/Breadcrumb/Main'
import LoadingScreen from 'react-loading-screen';
import DOMPurify from 'dompurify';

export default function RedirectSubpage({subpage}) {
    
    // const { subpage } = useParams();
    const { subpage: paramSubpage } = useParams();
    const actualSubpage = subpage || paramSubpage;

    const [apiData, setApiData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [parsedOthers, setParsedOthers] = useState(null);

    useEffect(() => {
        // Add icons to <li> elements after API data is rendered
        if (apiData?.latest_publication) {
            const container = document.querySelector('#latest_publications');
            if (container) {
                const listItems = container.querySelectorAll('li');
                listItems.forEach((li) => {
                    const icon = document.createElement('i');
                    icon.className = 'fal fa-arrow-alt-circle-right me-3 c-link';
                    li.prepend(icon);
                });
            }
        }
        if (apiData && apiData.others) {
            try {
              const parsed = JSON.parse(apiData.others); // Parse the JSON string
              setParsedOthers(parsed);
            } catch (error) {
              console.error('Error parsing JSON:', error);
            }
        }
    }, [apiData?.latest_publication]); // Depend on the `latest_publication` data

    useEffect(() => {
        debugger
        async function fetchData() {
            const BASE_URL =
                process.env.NODE_ENV === "production"
                    ? process.env.REACT_APP_BASE_URL
                    : process.env.REACT_APP_LOCAL_URL;
                
                const apiUrl = `${BASE_URL}/fpp/API/profile/${actualSubpage}`;

                console.log(apiUrl);
            try {
                const response = await fetch(apiUrl);
                // const response = await fetch(`http://localhost/IITTP/fpp/api/profile/00239`);
                if (!response.ok) {
                    throw new Error("Failed to fetch data from API");
                }
                // const response = await fetch(`http://localhost/IITTP/fpp/api/profile/00239`);
                
                debugger
                const result = await response.json();

                if (result.status == '1' ) {
                    setApiData(result);
                    // Pass the data to another page
                } else {
                    console.error("Invalid API status");
                    window.location.href = `https://old.iittp.ac.in/${actualSubpage}`;
                }
            } catch (err) {
                console.error("Error fetching API data", err);
                window.location.href = `https://old.iittp.ac.in/${actualSubpage}`;
            } finally {
                setLoading(false); // Stop loading spinner
            }
        }

        if (actualSubpage) {
            fetchData();
        }
    }, [actualSubpage]);

   return (
        <LoadingScreen
            loading={loading}
            bgColor="#f4f4f4"
            spinnerColor="#007bff"
            textColor="#555"
            // logoSrc="/path/to/logo.png" // Optional: Add your logo here
            text="IITT Faculty Profile Loading, please wait..."
        >
            { apiData && (
            <>
            <Header />
            <Breadcrumb title="Home" subtitle="Faculty Profile" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">
                        <div className="row">
                            <div className="col-lg-4 col-md-12 col-sm-12">
                                <div className="team-img-box">
                                    <Link to="/team-single">
                                        <img src={`${apiData.BASEURL}${apiData.main_img}`} alt="img" />
                                    </Link>
                                </div>
                            </div>
                            <div className="text-column col-lg-8 col-md-12 col-sm-12">
                                <div className="s-about-content pl-30 wow fadeInRight" data-animation="fadeInRight" data-delay=".2s" >
                                    <h2>{apiData.profile_name}</h2>
                                    <h4>{apiData.designation}</h4>
                                                                    
                                    <div className="per-info">
                                        
                                        <div className="info-text">
                                            <strong>Department</strong>
                                            {/* <p><Link to="/people/faculty/chemical-engineering-department">{apiData.department}</Link></p> */}
                                            <p><Link to="#">{apiData.department}</Link></p>
                                        </div>
                                        
                                        <div className="info-text">
                                            <strong>Contact</strong>
                                            <p>
                                                <i className="fal fa-phone" /> {apiData.phone}
                                            </p>
                                            <p>
                                                <i className="fal fa-envelope" /> {apiData.email}
                                            </p>
                                        </div>
                                        <div className="info-text">
                                            <strong>Website Links</strong>
                                            <p><i className="fal fa-globe" />
                                            {apiData.personal_weblink && (
                                                <a 
                                                    href={apiData.personal_weblink.startsWith('http') ? apiData.personal_weblink : `https://${apiData.personal_weblink}`} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                >
                                                    Personal Website
                                                </a>
                                            )}
                                            </p>
                                            {parsedOthers && typeof parsedOthers === 'object' && (
                                            Object.entries(parsedOthers).map(([websiteName, url], index) => (
                                                <p key={index}>
                                                <i className="fal fa-globe" />
                                                <a href={url} target="_blank" rel="noopener noreferrer">
                                                    {websiteName}
                                                </a>
                                                </p>
                                            )))}
                                        </div>
                                    </div>

                                    <p>{apiData.about}</p>
                                    <div className='text-dark'>

                                        <h3 className='c-headline'>Areas of Interest </h3>                               
                                        <ul className='ms-3' >
                                            {
                                                apiData.area.split('|').map((item,index) => (
                                                    <li key={index}><i className="fal fa-arrow-alt-circle-right me-3 c-link" />{item}</li>
                                                ))
                                            }
                                        </ul>  

                                        <h3 className='c-headline'>Education</h3>
                                        <ul className='ms-3' >
                                            {
                                                apiData.education.split('|').map((item,index) => (
                                                    <li key={index}><i className="fal fa-arrow-alt-circle-right me-3 c-link" />{item}</li>
                                                ))
                                            }
                                        </ul>

                                        <h3 className='c-headline'>Latest Publications</h3>
                                            <div id='latest_publications' dangerouslySetInnerHTML={{__html : DOMPurify.sanitize(apiData.latest_publication)}}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </>
        )
        
        // :(
        //     <>
        //     <p>No additional data available for this subpage.</p>
        //     {/* {(() => {
        //         window.location.href = `https://old.iittp.ac.in/${actualSubpage}`;
        //     })()} */}
        //     </>
        // ) 
        
        }

        </LoadingScreen>
    )
}
